export default "__VITE_ASSET__B9d9AM4R__"